import React from 'react';
import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import './shadow.css';

const HomepageHeading = ({ mobile }) => (
  <Container text style={{ paddingBottom: '12em' }}>
    <Header
      size="large"
      content="Crytpo Club"
      color="teal"
      className="shadow"
      style={{
        fontSize: mobile ? '2em' : '4em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '2.0em',
        fontFamily: 'Orbitron, sans-serif',
      }}
    />
    <Header
      size="small"
      content="Real time crypto analytics club for gaining an edge."
      style={{
        fontSize: mobile ? '1.5em' : '1.7em',
        fontWeight: 'normal',
        marginTop: mobile ? '1.0em' : '2.0em',
        marginBottom: mobile ? '1.0em' : '2.5em',
        color: 'white',
      }}
    />
    <Button
      className="gradient"
      primary
      size="huge"
      style={{ position: 'relative' }}
      as={Link}
      to="/signup"
    >
      Get Early Access
    </Button>
  </Container>
);
const HomePageLayout = () => {
  return (
    <Container>
      <Segment vertical>
        <Grid columns="equal" stackable>
          <Grid.Row divided textAlign="center">
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header inverted as="h2" icon>
                <Icon inverted circular color="green" name="line graph" />
                Real time momentum indicators
                <Header.Subheader>
                  Stay on top of instant momemtum indicators in the positive
                  direction, using real-time volume and price data
                </Header.Subheader>
              </Header>
            </Grid.Column>
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header inverted as="h2" icon>
                <Icon inverted circular color="red" name="comments" />
                World Class Support
                <Header.Subheader>
                  Members from our expert trading team are available via instant
                  chat to help with any questions or needs you may have. We
                  build features based on your immediate feedback!
                </Header.Subheader>
              </Header>
            </Grid.Column>
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header inverted as="h2" icon>
                <Icon inverted circular color="blue" name="users" />
                Exclusive Trading Community
                <Header.Subheader>
                  Interact with other members of our exclusive trading
                  community, share hypotheses, and learn from other traders.
                </Header.Subheader>
              </Header>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Container>
  );
};

const Home = () => {
  return (
    <Segment
      textAlign="center"
      style={{ minHeight: 700, padding: '1em 0em' }}
      vertical
      inverted
    >
      <HomepageHeading />
      <HomePageLayout />
    </Segment>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.jsx